import { render, staticRenderFns } from "./AdStats.vue?vue&type=template&id=5497f25c&"
import script from "./AdStats.vue?vue&type=script&lang=js&"
export * from "./AdStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ticketpoint/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5497f25c')) {
      api.createRecord('5497f25c', component.options)
    } else {
      api.reload('5497f25c', component.options)
    }
    module.hot.accept("./AdStats.vue?vue&type=template&id=5497f25c&", function () {
      api.rerender('5497f25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/AdStats.vue"
export default component.exports